import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'KAMA',
  version: 1,
  label: 'Kaufman Adaptive Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 35,
  inputs: [period('timeperiod', 30)],
  outputs: [line('kama', 'KAMA', COLOR.blue)],
  talib: { functions: ['KAMA'], expr: 'KAMA(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
